import { Location } from '@angular/common';
import { Component, ElementRef, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { preventDefault } from 'ol/events/Event';
import axios from 'src/app/Service/axios';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { OtherService } from 'src/app/Service/other.service';
declare let $: any;

@Component({
  selector: 'app-base-info',
  templateUrl: './base-info.component.html',
  styleUrls: ['./base-info.component.css']
})
export class BaseInfoComponent implements OnInit {

  tabView: number = 0;
  vehicleGroup: any;
  vehicleNames: any;
  searchFilter: any;
  vehicleTypes: any;
  tripReasons: any;
  requestTypes: any;
  requestReasons: any;
  model: any = {};

  constructor(private location: Location, private el: ElementRef, private otherService: OtherService, private notificationService: NotificationService, private gurdService: GurdServiceService) { }

  ngOnInit(): void {
    this.getVehicleNames();
  }

  //#region نام خودرو

  //دریافت لیست نام خودرو ها
  async getVehicleNames() {
    let res = JSON.parse((await axios.post(`GPSType_List`, {})).data.toString());
    this.vehicleNames = res;
  }

  // ثبت خودرو جدید
  async sabtNewVehicleName() {
    if (this.model.vehicleName) {
      this.otherService.Showspinner();
      const res = await axios.post(`GPSType_Save`, {
        iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
        strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),
        strComment: this.model.vehicleName
      });
      let resp = JSON.parse(res.data.toString())
      this.otherService.nonespinner();
      $('#addNewVehicle').modal('hide');
      if (resp.strError)
        return this.notificationService.showError(resp.strError);

      this.notificationService.showSuccess(`${this.model.vehicleName} با موفقیت به لیست خودروها افزوده شد`);
      this.model.vehicleName = '';
      this.getVehicleNames();
    }
  }
  //#endregion

  //#region نوع خودرو
  //دریافت لیست نوع خودرو
  async getVehicleType() {
    let res = JSON.parse((await axios.post(`MobileType_List`, {})).data.toString());
    this.vehicleTypes = res;
  }

  //ثبت نوع خودرو جدید
  async sabtNewVehicleType() {
    if (this.model.vehicleType) {
      this.otherService.Showspinner();
      const res = await axios.post(`MobileType_Save`, {
        iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
        strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),
        strComment: this.model.vehicleType
      });
      let resp = JSON.parse(res.data.toString())
      this.otherService.nonespinner();
      $('#addNewType').modal('hide');
      if (resp.strError)
        return this.notificationService.showError(resp.strError);

      this.notificationService.showSuccess(`${this.model.vehicleName} با موفقیت به نوع خودروها افزوده شد`);
      this.model.vehicleType = '';
      this.getVehicleType();
    }
  }

  //#endregion

  //#region گروه خودرو

  // دریافت گروه خودرو 
  async getVehicleGroups() {
    const res = await axios.post(`MobileGroup_List`, {});
    let resp = JSON.parse(res.data.toString())
    this.vehicleGroup = resp;
  }

  //ثبت گروه خودرو جدید
  async sabtNewVehicleGroup() {
    if (this.model.vehicleGroup) {
      this.otherService.Showspinner();
      const res = await axios.post(`MobileGroup_Save`, {
        iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
        strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),
        strComment: this.model.vehicleGroup
      });
      let resp = JSON.parse(res.data.toString())
      this.otherService.nonespinner();
      $('#addNewGroup').modal('hide');
      if (resp.strError)
        return this.notificationService.showError(resp.strError);

      this.notificationService.showSuccess(`${this.model.vehicleName} با موفقیت به گروه خودروها افزوده شد`);
      this.model.vehicleGroup = '';
      this.getVehicleGroups();
    }
  }
  //#endregion

  //#region دلیل سفر

  // دریافت لیست دلیل سفر 
  async getTripsList() {
    const res = await axios.post(`TripReason_List`, {});
    let resp = JSON.parse(res.data.toString())
    this.tripReasons = resp;
  }

  async sabtNewTripReason() {
    if (this.model.tripReason && this.model.tripConfirmationCount >= 0) {
      this.otherService.Showspinner();
      const res = await axios.post(`TripReason_Save`, {
        iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
        strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),
        strComment: this.model.tripReason,
        tiConfirmationLevel: this.model.tripConfirmationCount
      });
      let resp = JSON.parse(res.data.toString())
      this.otherService.nonespinner();
      $('#addNewTripReason').modal('hide');
      if (resp.strError)
        return this.notificationService.showError(resp.strError);

      this.notificationService.showSuccess(`${this.model.vehicleName} با موفقیت به لیست دلایل سفر افزوده شد`);
      this.model.tripReason = '';
      this.model.tripConfirmationCount = '';
      this.getTripsList();
    }
  }

  //#endregion

  //#region نوع درخواست امداد
  // دریافت لیست نوع درخواست 
  async getRequestType() {
    const res = await axios.post(`ReliefRequestType_List`, {});
    let resp = JSON.parse(res.data.toString())
    this.requestTypes = resp;
  }

  //ثبت نوع امداد جدید
  async sabtNewReliefType() {
    if (this.model.reliefType) {
      this.otherService.Showspinner();
      const res = await axios.post(`ReliefRequestType_Save`, {
        iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
        strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),
        strComment: this.model.reliefType
      });

      let resp = JSON.parse(res.data.toString())
      this.otherService.nonespinner();
      $('#addReliefType').modal('hide');
      if (resp.strError)
        return this.notificationService.showError(resp.strError);

      this.notificationService.showSuccess(`${this.model.vehicleName} با موفقیت به نوع امدادها افزوده شد`);
      this.model.reliefType = '';
      this.getRequestType();
    }
  }
  //#endregion

  //#region دلیل درخواست امداد
  // دریافت لیست دلیل امداد
  async getRequestReason() {
    const res = await axios.post(`Reason4Request_List`, {});
    let resp = JSON.parse(res.data.toString())
    this.requestReasons = resp;
  }

  //ثبت دلیل امداد جدید
  async sabtNewReliefReason() {
    if (this.model.reliefReason) {
      this.otherService.Showspinner();
      const res = await axios.post(`Reason4Request_Save`, {
        iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
        strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),
        strComment: this.model.reliefReason
      });

      let resp = JSON.parse(res.data.toString())
      this.otherService.nonespinner();
      $('#addReliefReason').modal('hide');
      if (resp.strError)
        return this.notificationService.showError(resp.strError);

      this.notificationService.showSuccess(`${this.model.vehicleName} با موفقیت به دلیل امدادها افزوده شد`);
      this.model.reliefReason = '';
      this.getRequestReason();
    }
  }
  //#endregion


  setActiveTab(index: any, e: any) {
    this.tabView = index;
    this.el.nativeElement.querySelectorAll('.nav-link').forEach((element: any) => {
      element.classList.remove('active')
    });
    document.getElementById(e.id)?.classList.add('active');
    switch (this.tabView) {
      case 1:
        this.getVehicleType();
        break;
      case 2:
        this.model.tripConfirmationCount = 0;
        this.getTripsList();
        break;
      case 3:
        this.getVehicleGroups();
        break;
      case 4:
        this.getRequestType();
        break;
      case 5:
        this.getRequestReason();
        break;
      default:
        break;
    }
  }

  async editItem(from: any, item: any) {
    if (from == 0) {
      let name = <HTMLInputElement>document.getElementById('row' + item.tiGPSType)?.childNodes[2]?.childNodes[0];
      let check = <HTMLElement>document.getElementById('row' + item.tiGPSType)?.childNodes[3].firstChild
      if (check.classList[3] == 'fa-edit') {
        name.disabled = false;
        check.classList.remove('fa-edit');
        check.classList.add('fa-check')
      } else if (check.classList.contains('fa-check')) {
        check.classList.remove('fa-check');
        check.classList.add('fa-circle-o-notch')

        let model = {
          iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
          strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),
          tiGPSType: item.tiGPSType,
          strComment: name.value
        }

        let resp = JSON.parse((await axios.post(`GPSType_Edit`, model)).data.toString());
        if (resp.iResult == 0)
          return this.notificationService.showError(resp.strError)

        this.notificationService.showSuccess('تغییرات با موفقیت اعمال شد');
        name.disabled = true;
        check.classList.remove('fa-circle-o-notch');
        check.classList.add('fa-edit');
      }
    }

    if (from == 1) {
      let name = <HTMLInputElement>document.getElementById('row' + item.tiMobileType)?.childNodes[1]?.childNodes[0];
      let check = <HTMLElement>document.getElementById('row' + item.tiMobileType)?.childNodes[2].firstChild


      if (check.classList[3] == 'fa-edit') {
        name.disabled = false;
        check.classList.remove('fa-edit');
        check.classList.add('fa-check')
      } else if (check.classList.contains('fa-check')) {
        check.classList.remove('fa-check');
        check.classList.add('fa-circle-o-notch')

        let model = {
          iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
          strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),
          tiMobileType: item.tiMobileType,
          strComment: name.value
        }

        let resp = JSON.parse((await axios.post(`MobileType_Edit`, model)).data.toString());
        if (resp.iResult == 0)
          return this.notificationService.showError(resp.strError)

        this.notificationService.showSuccess('تغییرات با موفقیت اعمال شد');
        name.disabled = true;
        check.classList.remove('fa-circle-o-notch');
        check.classList.add('fa-edit');
      }
    }

    if (from == 2) {
      let name = <HTMLInputElement>document.getElementById('row' + item.tiTripReason)?.childNodes[1]?.childNodes[0];
      let count = <HTMLInputElement>document.getElementById('row' + item.tiTripReason)?.childNodes[2]?.childNodes[0];
      let check = <HTMLElement>document.getElementById('row' + item.tiTripReason)?.childNodes[3].firstChild
      if (check.classList[3] == 'fa-edit') {
        name.disabled = false;
        count.disabled = false;
        check.classList.remove('fa-edit');
        check.classList.add('fa-check')
      } else if (check.classList.contains('fa-check')) {
        check.classList.remove('fa-check');
        check.classList.add('fa-circle-o-notch')

        let model = {
          iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
          strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),
          strComment: name.value,
          tiConfirmationLevel: Number(count.value),
          tiTripReason: item.tiTripReason,
        }

        let resp = JSON.parse((await axios.post(`TripReason_Edit`, model)).data.toString());
        if (resp.iResult == 0)
          return this.notificationService.showError(resp.strError)

        this.notificationService.showSuccess('تغییرات با موفقیت اعمال شد');
        name.disabled = true;
        count.disabled = true;
        check.classList.remove('fa-circle-o-notch');
        check.classList.add('fa-edit');
      }
    }

    if (from == 3) {
      let name = <HTMLInputElement>document.getElementById('row' + item.tiMobileGroup)?.childNodes[1]?.childNodes[0];
      let check = <HTMLElement>document.getElementById('row' + item.tiMobileGroup)?.childNodes[2].firstChild


      if (check.classList[3] == 'fa-edit') {
        name.disabled = false;
        check.classList.remove('fa-edit');
        check.classList.add('fa-check')
      } else if (check.classList.contains('fa-check')) {
        check.classList.remove('fa-check');
        check.classList.add('fa-circle-o-notch')

        let model = {
          iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
          strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),
          tiMobileGroup: item.tiMobileGroup,
          strComment: name.value
        }

        let resp = JSON.parse((await axios.post(`MobileGroup_Edit`, model)).data.toString());
        if (resp.iResult == 0)
          return this.notificationService.showError(resp.strError)

        this.notificationService.showSuccess('تغییرات با موفقیت اعمال شد');
        name.disabled = true;
        check.classList.remove('fa-circle-o-notch');
        check.classList.add('fa-edit');
      }
    }

    if (from == 4) {
      let name = <HTMLInputElement>document.getElementById('row' + item.tiReliefRequestType)?.childNodes[1]?.childNodes[0];
      let check = <HTMLElement>document.getElementById('row' + item.tiReliefRequestType)?.childNodes[2].firstChild
      if (check.classList[3] == 'fa-edit') {
        name.disabled = false;
        check.classList.remove('fa-edit');
        check.classList.add('fa-check')
      } else if (check.classList.contains('fa-check')) {
        check.classList.remove('fa-check');
        check.classList.add('fa-circle-o-notch')

        let model = {
          iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
          strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),
          tiReliefRequestType: item.tiReliefRequestType,
          strComment: name.value
        }

        let resp = JSON.parse((await axios.post(`ReliefRequestType_Edit`, model)).data.toString());
        if (resp.iResult == 0)
          return this.notificationService.showError(resp.strError)

        this.notificationService.showSuccess('تغییرات با موفقیت اعمال شد');
        name.disabled = true;
        check.classList.remove('fa-circle-o-notch');
        check.classList.add('fa-edit');
      }
    }

    if (from == 5) {
      let name = <HTMLInputElement>document.getElementById('row' + item.tiReason4Request)?.childNodes[1]?.childNodes[0];
      let check = <HTMLElement>document.getElementById('row' + item.tiReason4Request)?.childNodes[2].firstChild
      if (check.classList[3] == 'fa-edit') {
        name.disabled = false;
        check.classList.remove('fa-edit');
        check.classList.add('fa-check')
      } else if (check.classList.contains('fa-check')) {
        check.classList.remove('fa-check');
        check.classList.add('fa-circle-o-notch')

        let model = {
          iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
          strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),
          tiReason4Request: item.tiReason4Request,
          strComment: name.value
        }

        let resp = JSON.parse((await axios.post(`Reason4Request_Edit`, model)).data.toString());
        if (resp.iResult == 0)
          return this.notificationService.showError(resp.strError)

        this.notificationService.showSuccess('تغییرات با موفقیت اعمال شد');
        name.disabled = true;
        check.classList.remove('fa-circle-o-notch');
        check.classList.add('fa-edit');
      }
    }
  }

  async deleteItem(from: any, item: any) {
    if (from == 0) {
      $.confirm({
        title: `آیا از حذف این خودرو اطمینان دارید ؟`,
        content: '',
        type: 'red',
        buttons: {
          ok: {
            text: "حذف",
            btnClass: 'btn-success',
            keys: ['enter'],
            action: async () => {
              var model = {
                strSession: `${this.gurdService.decrypt(localStorage.getItem('Session')!)}`,
                iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
                tiGPSType: item.tiGPSType
              };


              let res = JSON.parse((await axios.post(`GPSType_Delete`, model)).data.toString());
              if (res.iResult == 0)
                return this.notificationService.showError(res.strError);

              this.notificationService.showSuccess(`${item.strComment} با موفقیت حذف شد`);
              this.getVehicleNames();
            }
          },
          cancel: {
            text: "لغو",
          }
        }
      });
    }

    if (from == 1) {
      $.confirm({
        title: `آیا از حذف این نوع خودرو اطمینان دارید ؟`,
        content: '',
        type: 'red',
        buttons: {
          ok: {
            text: "حذف",
            btnClass: 'btn-success',
            keys: ['enter'],
            action: async () => {
              var model = {
                strSession: `${this.gurdService.decrypt(localStorage.getItem('Session')!)}`,
                iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
                tiMobileType: item.tiMobileType
              };


              let res = JSON.parse((await axios.post(`MobileType_Delete`, model)).data.toString());
              if (res.iResult == 0)
                return this.notificationService.showError(res.strError);

              this.notificationService.showSuccess(`${item.strComment} با موفقیت حذف شد`);
              this.getVehicleType();
            }
          },
          cancel: {
            text: "لغو",
          }
        }
      });
    }

    if (from == 2) {
      $.confirm({
        title: `آیا از حذف این دلیل سفر اطمینان دارید ؟`,
        content: '',
        type: 'red',
        buttons: {
          ok: {
            text: "حذف",
            btnClass: 'btn-success',
            keys: ['enter'],
            action: async () => {
              var model = {
                strSession: `${this.gurdService.decrypt(localStorage.getItem('Session')!)}`,
                iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
                tiTripReason: item.tiTripReason
              };

              let res = JSON.parse((await axios.post(`TripReason_Delete`, model)).data.toString());
              if (res.iResult == 0)
                return this.notificationService.showError(res.strError);

              this.notificationService.showSuccess(`${item.strComment} با موفقیت حذف شد`);
              this.getTripsList();
            }
          },
          cancel: {
            text: "لغو",
          }
        }
      });
    }

    if (from == 3) {
      $.confirm({
        title: `آیا از حذف این گروه خودرو اطمینان دارید ؟`,
        content: '',
        type: 'red',
        buttons: {
          ok: {
            text: "حذف",
            btnClass: 'btn-success',
            keys: ['enter'],
            action: async () => {
              var model = {
                strSession: `${this.gurdService.decrypt(localStorage.getItem('Session')!)}`,
                iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
                tiMobileGroup: item.tiMobileGroup
              };


              let res = JSON.parse((await axios.post(`MobileGroup_Delete`, model)).data.toString());
              if (res.iResult == 0)
                return this.notificationService.showError(res.strError);

              this.notificationService.showSuccess(`${item.strComment} با موفقیت حذف شد`);
              this.getVehicleGroups();
            }
          },
          cancel: {
            text: "لغو",
          }
        }
      });
    }

    if (from == 4) {
      $.confirm({
        title: `آیا از حذف این نوع امداد اطمینان دارید ؟`,
        content: '',
        type: 'red',
        buttons: {
          ok: {
            text: "حذف",
            btnClass: 'btn-success',
            keys: ['enter'],
            action: async () => {
              var model = {
                strSession: `${this.gurdService.decrypt(localStorage.getItem('Session')!)}`,
                iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
                tiReliefRequestType: item.tiReliefRequestType
              };

              let res = JSON.parse((await axios.post(`ReliefRequestType_Delete`, model)).data.toString());
              if (res.iResult == 0)
                return this.notificationService.showError(res.strError);

              this.notificationService.showSuccess(`${item.strComment} با موفقیت حذف شد`);
              this.getRequestType();
            }
          },
          cancel: {
            text: "لغو",
          }
        }
      });
    }

    if (from == 5) {
      $.confirm({
        title: `آیا از حذف این دلیل امداد اطمینان دارید ؟`,
        content: '',
        type: 'red',
        buttons: {
          ok: {
            text: "حذف",
            btnClass: 'btn-success',
            keys: ['enter'],
            action: async () => {
              var model = {
                strSession: `${this.gurdService.decrypt(localStorage.getItem('Session')!)}`,
                iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
                tiReason4Request: item.tiReason4Request
              };

              let res = JSON.parse((await axios.post(`Reason4Request_Delete`, model)).data.toString());
              if (res.iResult == 0)
                return this.notificationService.showError(res.strError);

              this.notificationService.showSuccess(`${item.strComment} با موفقیت حذف شد`);
              this.getRequestType();
            }
          },
          cancel: {
            text: "لغو",
          }
        }
      });
    }
  }

  //قسمت جستجو
  searchbox(searchbox: any, value: any) {
    if (searchbox == 0) {
      if (!this.searchFilter) {
        this.searchFilter = this.vehicleNames;
      }

      if (value.length == 0) {
        this.vehicleNames = this.searchFilter;
        this.searchFilter = false;
      } else {
        this.vehicleNames = this.searchFilter.filter((x: any) => x.strComment.startsWith(value) || x.strGPSTypeStyle_strComment.startsWith(value))
      }
    }

    if (searchbox == 1) {
      if (!this.searchFilter) {
        this.searchFilter = this.vehicleTypes;
      }

      if (value.length == 0) {
        this.vehicleTypes = this.searchFilter;
        this.searchFilter = false;
      } else {
        this.vehicleTypes = this.searchFilter.filter((x: any) => x.strComment.startsWith(value))
      }
    }

    if (searchbox == 2) {
      if (!this.searchFilter) {
        this.searchFilter = this.tripReasons;
      }

      if (value.length == 0) {
        this.tripReasons = this.searchFilter;
        this.searchFilter = false;
      } else {
        this.tripReasons = this.searchFilter.filter((x: any) => x.strComment.startsWith(value))
      }
    }

    if (searchbox == 3) {
      if (!this.searchFilter) {
        this.searchFilter = this.vehicleGroup;
      }

      if (value.length == 0) {
        this.vehicleGroup = this.searchFilter;
        this.searchFilter = false;
      } else {
        this.vehicleGroup = this.searchFilter.filter((x: any) => x.strComment.startsWith(value))
      }
    }

    if (searchbox == 4) {
      if (!this.searchFilter) {
        this.searchFilter = this.requestTypes;
      }

      if (value.length == 0) {
        this.requestTypes = this.searchFilter;
        this.searchFilter = false;
      } else {
        this.requestTypes = this.searchFilter.filter((x: any) => x.strComment.startsWith(value))
      }
    }
  }

  goBack() {
    this.location.back();
  }

}
